import Wrapper from "../../Wrapper";

 const UploadOrderList = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Upload Order List</h3>
         </Wrapper>
         </>
     );
 }
 export default UploadOrderList;